module.exports = __webpack_public_path__ + "img/work2.e9de76a5.png";